import {type AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {ABTestImpressionAnalytic, AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas.ts'
import {type UserState} from '../../../../shared/UserState.ts'
import {CA} from '../../../shared/scripts/analytics/Analytics.ts'
import {ViewPopupHumorousDisableAdblock} from '../ui_popup/ui_popup_adblock/ViewPopupHumorousDisableAdblock.ts'

export class UIAdBlockController {
    static shouldShowSoftBlockPopup(userState: UserState | undefined, isAdblockActive: boolean): boolean {
        if(userState?.items.hasMembership()) return false
        if(isAdblockActive == false) return false
        if((userState?.karmaCompletedGameCount ?? 0) <= this.getSoftBlockGameLimitNumber()) return false
        return true
    }

    static getSoftBlockGameLimitNumber(): number {
        return 10
    }

    static showDisableAdblockPopup(continuationAction: () => void, isSoftPopup: boolean, canCancel: boolean) {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestImpressionAnalytics,
            category: AnalyticEventCategory.ABTestImpressionAnalytics,
            floatValue: ABTestImpressionAnalytic.AdblockPopupHumorous,
        }
        void CA.sendAnalyticEvent(eventData)
        const noCompletionAction = () => undefined
        new ViewPopupHumorousDisableAdblock(continuationAction, noCompletionAction, isSoftPopup, canCancel)
    }
}
